<template>
  <span
    :style="`margin-left: ${deep}rem; margin-right: 3px;`"
    class="pointer"
    @click="handleClick"
  >
    <i
      v-if="hasItems"
      class="fas"
      :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
    />
  </span>
</template>

<script>
export default {
  name: 'TreeGridExpandButton',
  props: {
    deep: {
      type: Number,
      required: true
    },
    expanded: {
      type: Boolean,
      required: true
    },
    hasItems: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: null,
      required: false
    }
  },
  computed: {
  },
  methods: {
    handleClick () {
      if (this.hasItems) {
        if (this.expanded) {
          this.$emit('close')
        } else {
          this.$emit('expand')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/treegrid/TreeGridExpandButton.vue